import { FormEvent, useState, Dispatch, SetStateAction, ChangeEvent, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import debounce from 'lodash/debounce';
import styles from '@features/showroom/sections/Map/Components/PostcodeFilter/PostcodeFilter.styles';
import { ILocationItems, ILocationStateGroups } from '@features/showroom/typescript';
import Button from '@components/Button/Button';
import Select from '@components/Select/Select';
type PropsType = {
  locations: Array<ILocationItems>;
  setFilterLocations: Dispatch<SetStateAction<Array<ILocationItems>>>;
  setCoordinate: Dispatch<SetStateAction<Array<ILocationItems>>>;
};
const PostcodeFilter = ({
  locations,
  setFilterLocations,
  setCoordinate
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const [filter, setFilter] = useState('');
  const [postCode, setPostCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const handleChooseLocation = e => {
    if (filter !== e) setFilter(e);
  };
  const debouncedChangeHandler = debounce(handleChooseLocation, 700);
  useEffect(() => {
    const filterLocation = locations.filter(item => item.state === filter);
    setCoordinate([]);
    setFilterLocations(filterLocation.length > 0 ? filterLocation : locations);
  }, [filter, locations, setCoordinate, setFilterLocations]);

  // group by state
  const options: Array<ILocationStateGroups> = [{
    value: '0',
    name: t('showroom.showAllStates')
  }, ...new Map(locations.map(item => [item.state, {
    value: item.state,
    name: item.state
  }])).values()];
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const pattern = /(^\d{5}$)|(^\d{2}-\d{3}$)|(^\d{2,5})/;
    const filterLocations = locations.filter(item => item.postcode.includes(postCode));
    if (pattern.test(postCode) && filterLocations.length > 0) {
      setCoordinate([]);
      setFilterLocations(filterLocations);
    } else {
      setFilterLocations(locations);
      setErrorMessage(t('showroom.zipCodeErrorValidate'));
    }
  };
  const handlePostcodeInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const patternDecimal = /(\d)/;
    const patternPostCode = /(^\d{2}-\d{3}$)/;
    if (e.currentTarget.value.length <= 5 && patternDecimal.test(e.currentTarget.value) || patternPostCode.test(e.currentTarget.value)) {
      setPostCode(e.currentTarget.value);
    } else if (e.currentTarget.value.length < 1) {
      setPostCode('');
      setFilterLocations(locations);
    }
    setErrorMessage('');
  };
  return <>
      <div>
        <div sx={styles.formWrapper}>
          <form sx={styles.form(errorMessage)} className={errorMessage && 'error'} action="" onSubmit={e => handleSubmit(e)}>
            <input sx={styles.postCodeInput(!!errorMessage)} placeholder={t('showroom.zipCodePlaceholder')} value={postCode} onChange={e => handlePostcodeInputChange(e)} id="showroom-postcode-filter" aria-label={t('showroom.zipCodePlaceholder')} aria-invalid={!!errorMessage} aria-errormessage={errorMessage ? 'showroom-postcode-error' : undefined} />

            <Button variant="default" type="submit">
              {t('search')}
            </Button>
          </form>
          {errorMessage && <div id="showroom-postcode-error" role="alert" sx={{
          color: 'accent700',
          fontSize: 'caption',
          mt: 1
        }}>
              {errorMessage}
            </div>}
        </div>
      </div>
      <div>
        <Select addSx={styles.inputSelect} options={options} value={filter} placeholder={t('showroom.selectStatePlaceholder')} onChange={debouncedChangeHandler} id="showroom-state-select" ariaLabel={t('showroom.selectStatePlaceholder')} />
      </div>
    </>;
};
export default PostcodeFilter;